import styled from '@emotion/styled'
import { BlockComponent } from 'lib'
import { ColorProperties, FlexMods, getColorFromRange, Overflow } from 'components/styles'
import { composeCssVars, getCssVar, setCssVar } from 'lib/css/CssVarProperties'
import { ifBefore } from 'components/styles/primitives/selectors/ifBefore'
import { FillerContent } from 'components/styles/definitions/fillerContent'
import { PositionedFrom, PositionMods } from 'components/styles/primitives/modifiers/position/positions'
import { ColorMods } from 'components/styles/primitives/modifiers/text/colorMods'
import { CornerMods } from 'components/styles/primitives/modifiers/shape/corners'
import { SizeMods } from 'components/styles/primitives/modifiers/size'
import type { ColorRanges } from 'components/styles/primitives/modifiers/color/types'
import { css } from '@emotion/react'

interface Props {
	colorRange: ColorRanges<number>
	value: number
}

enum CSSProps {
	fillPercent = 'fill-percent',
	width = 'width'
}

const GaugeTransitions = css({ transition: 'height 1s, background 1s ease' })

const GaugeView = styled.div`
	${PositionMods.Relative}
	${Overflow.Hidden}
	${FlexMods.IntrinsicallySized}
	${SizeMods({ height: '100%', minHeight: '40px', width: getCssVar(CSSProps.width) })}
	${CornerMods.FullyRounded}
	${ColorMods({ background: ColorProperties.Lighter })}
	${GaugeTransitions}
	
	${ifBefore([
		FillerContent,
		PositionedFrom('bottom'),
		ColorMods({ background: ColorProperties.Base }),
		SizeMods({ height: getCssVar(CSSProps.fillPercent) }),
		GaugeTransitions
	])}
`

/**
 * Vertical Gauge is a visual representation of a percentage
 * @param {Color} colorRange - The color of the background and the fill
 * @param {number} value - data valu, between 0 and 1
 * @returns
 */
export const VerticalGauge: BlockComponent<Props> = ({ colorRange, value }) => {
	return (
		<GaugeView
			style={composeCssVars(
				getColorFromRange(colorRange, value).toCssVars(),
				setCssVar(CSSProps.fillPercent, `${value * 100}%`),
				setCssVar(CSSProps.width, '8px')
			)}
		/>
	)
}
